export enum FieldType {
  text = "text",
  multiline_text = "multiline_text",
  radio_group = "radio_group",
  select = "select",
  checkbox = "checkbox",
  date = "date",
  datetime = "datetime",
  time = "time",
  signature = "signature",
  image = "image",
  file = "file",
  paragraph = "paragraph",
}

export type FieldItem = {
  id: string;
  type: FieldType;
  name?: string;
  placeholder?: string;
  helperText?: string;
  width?: number;
  options?: string[];
  multiple?: boolean;
  search?: boolean;
  other?: boolean;
  multiline?: boolean;
  mask?: string;
  value?: any;
  rows?: number;
  required?: boolean;
  full_width?: boolean;
  readonly?: boolean;
};

export type RowItem = {
  id: string;
  fields: FieldItem[];
};

export type BlockItem = {
  id: string;
  name: string;
  rows: RowItem[];
};

export type TemplateRowItem = {
  fields: Omit<FieldItem, "id">[];
};
export type TemplateBlockItem = {
  name: string;
  icon: string;
  rows: TemplateRowItem[];
};
export type TemplateGroup = {
  name: string;
  templates: TemplateBlockItem[];
};
